import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';

// config
import { appConfig } from '../../../config/app-config';

// Core
import { ErrorMessage } from '../../../core/model/error-message';
import { IBoolResult, BoolResult } from '../../../core/interfaces/bool-result';
import { JsonFormViewComponent } from '../../../core/json-form/material/json-form-view/json-form-view.component';

// Redux
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../core/store/store';

// own module
import { mangelConfig } from '../../../maengel/config/mangel.config';
import { MaengelService } from '../../service/maengel.service';

const enum SubView {
   HIDE                 = 0,
   SHOW_MAENGEL_DETAILS = 1 << 1,  // 2
   // exceptions
   DATA_NOT_AVAILABLE   = 1 << 10, // 1024
   INTERNAL_ERROR       = 1 << 11  // 2048
}

@Component({
   selector: 'app-maengeldetail-mdlg',
   templateUrl: './maengeldetail-mdlg.component.html',
   styleUrls: ['./maengeldetail-mdlg.component.scss'],
   providers: [MaengelService]
})
export class MaengeldetailMdlgComponent implements OnInit, OnDestroy {

   // error
   public _errMsgSubView1 = '';
   public _errMsgSubViewIntErr = '';
   // pages
   private _subView = SubView.HIDE;

   // json schema
   @select((s: IAppState) => s.mangelState.mangelDetailJss) _mangelDetailJss$;

   // input
   @Input('titel') _titel = '';
   @Input('showCancelButton') _showCancelButton = false;
   @Input('showSubmitButton') _showSubmitButton = false;

   // events
   @Output() cancelEvent = new EventEmitter<null>();
   @Output() submitEvent = new EventEmitter<null>();
   @Output() errorEvent = new EventEmitter<ErrorMessage>();

   // child
   @ViewChild(JsonFormViewComponent) _jsonFormView: JsonFormViewComponent = null;

   constructor(
      private _maengelService: MaengelService
   ) { }

   ngOnInit() {
   }

   ngOnDestroy(): void {
      this.onLateDestroy();
   }

   // ----------------------------------------------------------------------------------------------
   // -- onInit/onDestroy
   // ----------------------------------------------------------------------------------------------
   private onLateInit(
      uid: string
   ): void {
      // -->>ASY - reqest maengel detail
      this._maengelService.loadMaengelDetail(uid)
      .then((boolResult: IBoolResult) => {
         // connection result ok!
         // open modal dialog
         this._jsonFormView.resetContent();
         this._subView = SubView.SHOW_MAENGEL_DETAILS;
         return;
      })
      .catch((err: ErrorMessage) => {
         // HTTPErrorResponse or internal error
         this.errorEvent.emit(err);
      });
   }

   private onLateDestroy(): void {
      this._maengelService.resetMaengelDetail();
   }

   // ----------------------------------------------------------------------------------------------
   // -- Error
   // ----------------------------------------------------------------------------------------------
   private showErrMsgSubView1(msg: string): void {
      this._errMsgSubView1 = msg;
      setTimeout(() => {
         this._errMsgSubView1 = '';
      }, appConfig.app.errMsgDurationToShow);
   }

   // ----------------------------------------------------------------------------------------------
   // -- Visibility
   // ----------------------------------------------------------------------------------------------
   public openDialog(
      uid: string                // uid of Mängel Detail to edit
   ): void {
      this.onLateInit(uid);
   }
   public closeDialog(): void {
      this._subView = SubView.HIDE;
      this.onLateDestroy();
   }
   // Pages
   public showView(): boolean            { return this._subView !== SubView.HIDE; }
   public showSubView1(): boolean        { return this._subView === SubView.SHOW_MAENGEL_DETAILS; }
   // Exceptions
   public showSubViewNoData(): boolean   { return this._subView === SubView.DATA_NOT_AVAILABLE; }
   public showSubViewIntErr(): boolean   { return this._subView === SubView.INTERNAL_ERROR; }

   // ----------------------------------------------------------------------------------------------
   // -- SubView 1
   // ----------------------------------------------------------------------------------------------
   public onCancelSubPage1() {
      this.closeDialog();
      this.cancelEvent.emit();
   }
   public onSubmitSubPage1() {
      this.closeDialog();
      this.submitEvent.emit();
   }

   // -- Events from JsonForm -------------------
   public onCancelJsonFormView(): void {
      this.closeDialog();
   }
   public onSubmitJsonFormView(formValue: any): void {
      this.closeDialog();

       // -->>ASY - reqest maengel detail
      this._maengelService.saveMaengelDetail(formValue)
      .then((boolResult: IBoolResult) => {
         // connection result ok!
         return;
      })
      .catch((err: ErrorMessage) => {
         // HTTPErrorResponse or internal error
         this.errorEvent.emit(err);
      });
   }

   // ----------------------------------------------------------------------------------------------
   // -- SubView - Internal Error
   // ----------------------------------------------------------------------------------------------
   public onNextSubViewIntErr() {
      this.closeDialog();
      this.cancelEvent.emit();
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/maengel/compv/maengeldetail-mdlg/maengeldetail-mdlg.component.ts